import React, {useEffect, useState} from 'react';
import FormHome from "../components/FormHome";
import EtapesProjet from "../components/EtapesProjet";
import {useParams, useLocation, useNavigate} from "react-router-dom";
import {API_URL} from "../config";


const VideosClip = () => {

    const {slug} = useParams();
    const navigate = useNavigate();

    const location = useLocation();
    const [projets, setProjets] = useState([]);

    // Récupère le dernier segment de l'URL si useParams ne marche pas
    const currentSlug = slug || location.pathname.split('/').filter(Boolean).pop();

    useEffect(() => {
        const fetchData = () => {
            fetch(`${API_URL}/videos/category/${currentSlug}?limit=2`)
                .then((res) => res.json())
                .then((data) => {
                    setProjets(data.videos || []);
                });
        };

        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [currentSlug]);

    return(
        <>
            <div className="pb-32 pt-64 videos vertical-section">
                <div className="grid grid-cols-2 gap-x-14 mx-32">
                    <div className="publicitaires">
                        <h1 className="text-title-xl">Vidéos clip</h1>
                        <p>SNotre agence de production audiovisuelle basée à Bordeaux réalise aussi des clips musicaux originaux pour les artistes qui cherchent à se démarquer. Nous savons combien l'impact visuel est important dans ce domaine, c'est pourquoi nous travaillons en collaboration avec chaque artiste pour créer un clip qui reflète leur univers et leur personnalité. Nous offrons une large gamme de styles, du plus traditionnel au plus innovant, pour répondre à toutes les envies.
                        </p>
                    </div>
                    <div className="publicitaires">
                        <div className="line"></div>
                        <p>Notre équipe de professionnels est passionnée par la création de contenu audiovisuel de qualité. Nous utilisons les dernières technologies pour réaliser des clips qui captivent votre audience. Nous nous engageons à comprendre vos besoins, vos objectifs de communication et votre budget pour vous fournir une vidéo sur mesure. Fiez-vous à notre savoir-faire pour réaliser un clip qui racontera votre histoire de façon unique et marquante.


                        </p>
                    </div>
                </div>

                <div className="lesplus mx-32 mt-20 gap-x-20">
                    <div className="leplus-matos">
                        <h3>Matériel professionnel</h3>
                        <p>Lorem ipsum dolor sit amet
                            ti sociosqu ad litora torquent per conubia</p>
                    </div>

                    <div className="leplus-plus">
                        <h3>Un + pour votre entreprise</h3>
                        <p>Lorem ipsum dolor sit amet
                            ti sociosqu ad litora torquent per conubia</p>
                    </div>

                    <div className="leplus-bdx">
                        <h3>Proximité: <span>On est Bordelais !</span></h3>
                        <p>Lorem ipsum dolor sit amet
                            ti sociosqu ad litora torquent per conubia</p>
                    </div>
                </div>

            </div>

            <EtapesProjet/>

            <div className="autres px-32 py-16">
                <h2 className="font-bold text-f-40">Quelques réalisations<span>.</span></h2>
                <div className="autres-videos mt-8">
                    <div className="autres-videos-api">
                        {projets.map((projet) => (
                            <div className="card" key={projet.id}>
                                {projet.thumbnail ? (
                                    <img alt={projet.title} src={`${projet.thumbnail}`}/>
                                ) : (
                                    <div className="card-no-thumb">Pas d'aperçu</div>
                                )}
                                <h3 className="mt-2">{projet.title}</h3>
                                <p>{projet.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="autres-videos-bloc">
                        <p>Envie d'en voir plus ? </p>
                        <a onClick={() => navigate(`/realisations?cat=${currentSlug}`)} style={{cursor: 'pointer'}}>
                            Voir les réalisations
                        </a>
                    </div>


                </div>
            </div>

            <FormHome/>


    </>

    )
}

export default VideosClip